function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 12,
  y: 12,
  width: 28,
  height: 48,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 12h28v48H12z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.837 27.125l-8.158-10.792a.86.86 0 00-1.358 0l-8.158 10.792c-.405.536-.008 1.289.68 1.289h4.695v26.758a.83.83 0 00.83.828h5.262a.83.83 0 00.831-.828V28.414h4.697c.687 0 1.084-.753.679-1.29z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.837 27.125l-8.158-10.792a.86.86 0 00-1.358 0l-8.158 10.792c-.405.536-.008 1.289.68 1.289h4.695v26.758a.83.83 0 00.83.828h5.262a.83.83 0 00.831-.828V28.414h4.697c.687 0 1.084-.753.679-1.29z",
  fill: "#F8A6B1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.68 16.333l3.19-2.412-3.19 2.412zm8.157 10.792l-3.19 2.412 3.19-2.412zM25.32 16.333l-3.19-2.412 3.19 2.412zm-8.157 10.792l3.19 2.412-3.19-2.412zm5.375 1.289h4v-4h-4v4zm6.923 0v-4h-4v4h4zm-5.972-9.669l8.157 10.792 6.382-4.825-8.158-10.79-6.381 4.823zm5.022 0a3.14 3.14 0 01-5.022 0l6.381-4.824c-1.936-2.561-5.804-2.561-7.74 0l6.381 4.824zm-8.157 10.792l8.157-10.792-6.381-4.824-8.158 10.791 6.382 4.825zm-2.511-5.123c2.334 0 4.265 2.802 2.51 5.123l-6.38-4.825c-2.566 3.393.16 7.702 3.87 7.702v-8zm4.695 0h-4.695v8h4.695v-8zm4 30.758V28.414h-8v26.758h8zM23.368 52a3.17 3.17 0 013.17 3.172h-8A4.83 4.83 0 0023.368 60v-8zm5.262 0H23.37v8h5.261v-8zm-3.169 3.172A3.17 3.17 0 0128.631 52v8a4.83 4.83 0 004.83-4.828h-8zm0-26.758v26.758h8V28.414h-8zm8.697-4H29.46v8h4.697v-8zm-2.512 5.123c-1.754-2.32.177-5.123 2.511-5.123v8c3.71 0 6.436-4.309 3.87-7.702l-6.38 4.825z",
  fill: "#fff",
  mask: "url(#a)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.967,
  y: 0,
  width: 50.066,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgArrowSuggestion = function SvgArrowSuggestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 72,
    viewBox: "0 0 52 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowSuggestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_suggestion.61659eca.svg";
export { ForwardRef as ReactComponent };